var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import useFormApi from "@data-driven-forms/react-form-renderer/dist/cjs/use-form-api";
import { usePresentationComponent } from "../../../AppContext";
export var Basic = function (_a) {
    var context = _a.context, children = _a.children, className = _a.className, as = _a.as, fields = _a.fields, extraProps = __rest(_a, ["context", "children", "className", "as", "fields"]);
    var BasicComponent = usePresentationComponent(context ? context + ".basic" : "") || as;
    var Component = BasicComponent || React.Fragment;
    var props = __assign({ className: className }, extraProps);
    if (!BasicComponent) {
        delete props.className;
        // @ts-ignore
        delete props.component;
        // @ts-ignore
        delete props.name;
    }
    return React.createElement(Component, __assign({}, props), children);
};
export var ReactiveBasic = function (props) {
    var formOptions = useFormApi();
    return React.createElement(Basic, __assign({}, props),
        " ",
        formOptions.renderForm(props.fields, formOptions),
        " ");
};
